import { Component, OnInit } from '@angular/core';
import { INDRABookingComService } from '@ibe.services/booking-com.indra.service';

@Component({
  selector: 'app-partner-hotel-location',
  templateUrl: './partner-hotel-location.indra.component.html',
  styleUrls: ['./partner-hotel-location.component.scss']
})
export class INDRAPartnerHotelLocationComponent implements OnInit {

	hotelName: string;
	description: string;
	address: string;
	url;

	constructor(
		private bookingComService: INDRABookingComService
	) {
		const hotel = this.bookingComService.getHotel();
		this.hotelName = hotel.hotelInfo.hotel_name;
		this.description = hotel.hotelData.hotel_description;
		this.address = hotel.hotelInfo.address;
	}


	ngOnInit() {
		if (this.address) {
			this.url = this.bookingComService.INDRA_getGoogleLocation(this.address);
		}
	}

}
